module.exports = __webpack_public_path__ + "static/media/aliexpress.e4f91e14.png";